import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12c0 -4.243 0 -6.364 1.318 -7.682s3.44 -1.318 7.682 -1.318s6.364 0 7.682 1.318s1.318 3.44 1.318 7.682s0 6.364 -1.318 7.682s-3.44 1.318 -7.682 1.318s-6.364 0 -7.682 -1.318s-1.318 -3.44 -1.318 -7.682","key":"svg-0"}],["path",{"d":"M6 8l5 8","key":"svg-1"}],["path",{"d":"M6 16l5 -8","key":"svg-2"}],["path",{"d":"M18 11v4c0 1.1 -.517 .997 -1.5 .997a2.5 2.5 0 0 1 -2.5 -2.497a2.5 2.5 0 0 1 2.5 -2.5l1.5 0v-3","key":"svg-3"}]]

const IconBrandAdobeXd = createReactComponent('outline', 'brand-adobe-xd', 'BrandAdobeXd', __iconNode);

export default IconBrandAdobeXd;